import Head from 'next/head';
import { HeadingRegular } from '@pensionbee/honeypot-ui';
import { ThemedImage } from '@/domains/theme/ThemedImage';
import { ReactElement } from 'react';
import HeaderlessMobileLayout from '@/domains/shared/components/layouts/HeaderlessMobileLayout';
import { usePlatformInfo } from '@/domains/shared/hooks/useIsNative';

const JailbrokenOrRootedScreen = () => {
  const { isIOS: isIosPlatform, isAndroid: isAndroidPlatform } =
    usePlatformInfo();

  let errorMessage: string = '';

  if (isIosPlatform) {
    errorMessage = `We've detected your device is jailbroken. Please remove or disable jailbreak and restart the app.`;
  } else if (isAndroidPlatform) {
    errorMessage = `We've detected your device is rooted. Please remove or disable root access and restart the app.`;
  }

  return (
    <>
      <Head>
        <title>{errorMessage}</title>
      </Head>
      <section className="flex bg-background h-screen absolute inset-0 flex-col justify-center items-center px-20 max-w-screen-sm mx-auto">
        <div className="flex justify-center items-center mt-28">
          <ThemedImage name="errorIcon" alt="Error" width={120} height={120} />
        </div>
        <div className="pt-28">
          <HeadingRegular as="h1">{errorMessage}</HeadingRegular>
        </div>
      </section>
    </>
  );
};

export default JailbrokenOrRootedScreen;

JailbrokenOrRootedScreen.getLayout = function getLayout(page: ReactElement) {
  return <HeaderlessMobileLayout>{page}</HeaderlessMobileLayout>;
};
